<div [class]=" modeDaltonien(slot.usedRate) + ' text-center'"
     [style]="'--cell: ' + getColor(slot.usedRate) + ';'"
>
  <div style="cursor: pointer" (click)="openDialog(slot)">
    {{showMode(slot)}}
  </div>
  <div *ngIf="showModel.showSequences" style="overflow-x: hidden; text-overflow: ellipsis; white-space: nowrap;">
    <ngb-accordion [destroyOnHide]="false" [closeOthers]="true" #acc="ngbAccordion"
                   *ngIf="slot.sequences && slot.sequences.length > 0">
      <ngb-panel *ngFor="let sequence of slot.sequences">
        <ng-template ngbPanelTitle class="text-center">
          <div class="card-seq" [title]="sequence.campaignName + '(' + sequence.status +')'">
            <b>{{sequence.campaignName}} ({{sequence.status}}) </b>
          </div>
        </ng-template>
        <ng-template ngbPanelContent>
          <div class="row margeTopSM" *ngIf="verify(sequence.campaignName)">
            <div class="col-md-5">
              <h5>
                {{traductionsKeysEnum.CAMPAIGN_NAME | translate}}:
              </h5>
            </div>
            <div class="col-md-7 text-center">
              <div class="card-span" [style]="'--span: ' + '#FFFAFA'">
                {{sequence.campaignName}}
              </div>
            </div>
          </div>
          <div class="row margeTopSM" *ngIf="verify(sequence.campaignType)">
            <div class="col-md-5">
              <h5>
                {{traductionsKeysEnum.CAMPAIGN_TYPE | translate}}:
              </h5>
            </div>
            <div class="col-md-7 text-center">
              <div class="card-span" [style]="'--span: ' + '#FFFAFA'">
                {{sequence.campaignType}}
              </div>
            </div>
          </div>
          <div class="row margeTopSM" *ngIf="verify(sequence.campaignCode)">
            <div class="col-md-5">
              <h5>
                {{traductionsKeysEnum.CAMPAIGN_CODE | translate}}:
              </h5>
            </div>
            <div class="col-md-7 text-center">
              <div class="card-span" [style]="'--span: ' + '#FFFAFA'">
                {{sequence.campaignCode}}
              </div>
            </div>
          </div>
          <div class="row margeTopSM" *ngIf="verify(sequence.codeCouplage)">
            <div class="col-md-5">
              <h5>
                {{traductionsKeysEnum.PAIRING_CODE | translate}}:
              </h5>
            </div>
            <div class="col-md-7 text-center">
              <div class="card-span" [style]="'--span: ' + '#FFFAFA'">
                {{sequence.codeCouplage}}
              </div>
            </div>
          </div>


          <div class="row margeTopSM" *ngIf="verify(sequence.codeSecteurs)">
            <div class="col-md-5">
              <h5>
                {{traductionsKeysEnum.SECTOR_CODE | translate}}:
              </h5>
            </div>
            <div class="col-md-7 text-center">
              <div class="card-span" [style]="'--span: ' + '#FFFAFA'">
                {{sequence.codeSecteurs}}
              </div>
            </div>
          </div>

          <div class="row margeTopSM" *ngIf="verify(sequence.campaignStartDate)">
            <div class="col-md-5">
              <h5>
                {{traductionsKeysEnum.START_CAMPAIGN | translate}}:
              </h5>
            </div>
            <div class="col-md-7 text-center">
              <div class="card-span" [style]="'--span: ' + '#FFFAFA'">
                {{sequence.campaignStartDate | date: 'EEE d MMMM à HH:mm'}}
              </div>
            </div>
          </div>
          <div class="row margeTopSM" *ngIf="verify(sequence.campaignEndDate)">
            <div class="col-md-5">
              <h5>
                {{traductionsKeysEnum.END_CAMPAIGN | translate}}:
              </h5>
            </div>
            <div class="col-md-7 text-center">
              <div class="card-span" [style]="'--span: ' + '#FFFAFA'">
                {{sequence.campaignEndDate | date: 'EEE d MMMM à HH:mm'}}
              </div>
            </div>
          </div>
          <div class="row margeTopSM" *ngIf="verify(sequence.clientId)">
            <div class="col-md-5">
              <h5>
                {{traductionsKeysEnum.CUSTOMER_ID | translate}}:
              </h5>
            </div>
            <div class="col-md-7 text-center">
              <div class="card-span" [style]="'--span: ' + '#FFFAFA'">
                {{sequence.clientId}}
              </div>
            </div>
          </div>
          <div class="row margeTopSM" *ngIf="verify(sequence.clientName)">
            <div class="col-md-5">
              <h5>
                {{traductionsKeysEnum.CUSTOMER_NAME | translate}}:
              </h5>
            </div>
            <div class="col-md-7 text-center">
              <div class="card-span" [style]="'--span: ' + '#FFFAFA'">
                {{sequence.clientName}}
              </div>
            </div>
          </div>
          <div class="row margeTopSM" *ngIf="verify(sequence.natureId)">
            <div class="col-md-5">
              <h5>
                {{traductionsKeysEnum.OF_NATURE | translate}}:
              </h5>
            </div>
            <div class="col-md-7 text-center">
              <div class="card-span" [style]="'--span: ' + '#FFFAFA'">
                {{sequence.natureId}}
              </div>
            </div>
          </div>
          <div class="row margeTopSM" *ngIf="verify(sequence.natureAbrege)">
            <div class="col-md-5">
              <h5>
                {{traductionsKeysEnum.NATURE_ABBREVIATES | translate}}:
              </h5>
            </div>
            <div class="col-md-7 text-center">
              <div class="card-span" [style]="'--span: ' + '#FFFAFA'">
                {{sequence.natureAbrege}}
              </div>
            </div>
          </div>
          <div class="row margeTopSM" *ngIf="verify(sequence.numNature)">
            <div class="col-md-5">
              <h5>
                {{traductionsKeysEnum.NATURE_NUMBER | translate}}:
              </h5>
            </div>
            <div class="col-md-7 text-center">
              <div class="card-span" [style]="'--span: ' + '#FFFAFA'">
                {{sequence.numNature}}
              </div>
            </div>
          </div>
          <div class="row margeTopSM" *ngIf="verify(sequence.preferencePos)">
            <div class="col-md-5">
              <h5>
                {{traductionsKeysEnum.PREFERENCE_POS | translate}}:
              </h5>
            </div>
            <div class="col-md-7 text-center">
              <div class="card-span" [style]="'--span: ' + '#FFFAFA'">
                {{sequence.preferencePos}}
              </div>
            </div>
          </div>
          <div class="row margeTopSM" *ngIf="verify(sequence.preferenceType)">
            <div class="col-md-5">
              <h5>
                {{traductionsKeysEnum.PREFERENCE_TYPE | translate}}:
              </h5>
            </div>
            <div class="col-md-7 text-center">
              <div class="card-span" [style]="'--span: ' + '#FFFAFA'">
                {{sequence.preferenceType}}
              </div>
            </div>
          </div>
          <div class="row margeTopSM" *ngIf="verify(sequence.spotDuration)">
            <div class="col-md-5">
              <h5>
                {{traductionsKeysEnum.SPOT_DURATION | translate}}:
              </h5>
            </div>
            <div class="col-md-7 text-center">
              <div class="card-span" [style]="'--span: ' + '#FFFAFA'">
                {{sequence.spotDuration + ' s'}}
              </div>
            </div>
          </div>
          <div class="row margeTopSM" *ngIf="verify(sequence.spotCodeSecteur)">
            <div class="col-md-5">
              <h5>
                {{traductionsKeysEnum.SECTOR_SPOT_CODE | translate}}:
              </h5>
            </div>
            <div class="col-md-7 text-center">
              <div class="card-span" [style]="'--span: ' + '#FFFAFA'">
                {{sequence.spotCodeSecteur}}
              </div>
            </div>
          </div>


          <div class="row margeTopSM" *ngIf="verify(sequence.status)">
            <div class="col-md-5">
              <h5>
                {{traductionsKeysEnum.STATUT | translate}}:
              </h5>
            </div>
            <div class="col-md-7 text-center">
              <div class="card-span" [style]="'--span: ' + '#FFFAFA'">
                {{sequence.status}}
              </div>
            </div>
          </div>

          <div class="row margeTopSM" *ngIf="verify(sequence.diffusionStatusLabel)">
            <div class="col-md-5">
              <h5>
                {{traductionsKeysEnum.BROADCAST_STATUS | translate}}:
              </h5>
            </div>
            <div class="col-md-7 text-center">
              <div class="card-span" [style]="'--span: ' + '#FAF0E6'">
                {{sequence.diffusionStatusLabel}}
              </div>
            </div>
          </div>

          <div class="row margeTopSM" *ngIf="sequence.diffusionStatusLabel">
            <div class="col-md-5">
              <h5>
                {{traductionsKeysEnum.BROADCAST_STATUS | translate}}:
              </h5>
            </div>
            <div class="col-md-7 text-center">
              <div class="card-span" [style]="'--span: ' + '#FFFAFA'">
                {{sequence.diffusionStatusLabel}}
              </div>
            </div>
          </div>

          <div class="row margeTopSM" *ngIf="verify(sequence.technicalStatus)">
            <div class="col-md-5">
              <h5>
                {{traductionsKeysEnum.TECHNICAL_CONDITION | translate}}:
              </h5>
            </div>
            <div class="col-md-7 text-center">
              <div class="card-span" [style]="'--span: ' + '#FFFAFA'">
                {{sequence.technicalStatus}}
              </div>
            </div>
          </div>
          <div class="row margeTopSM" *ngIf="verify(sequence.creationDate)">
            <div class="col-md-5">
              <h5>
                {{traductionsKeysEnum.CREATION_DATE | translate}}:
              </h5>
            </div>
            <div class="col-md-7 text-center">
              <div class="card-span" [style]="'--span: ' + '#FFFAFA'">
                {{sequence.creationDate | date: 'EEE d MMMM à HH:mm'}}
              </div>
            </div>
          </div>
          <div class="row margeTopSM" *ngIf="verify(sequence.updateDate)">
            <div class="col-md-5">
              <h5>
                {{traductionsKeysEnum.MODIFICATION_DATE | translate}}:
              </h5>
            </div>
            <div class="col-md-7 text-center">
              <div class="card-span" [style]="'--span: ' + '#FFFAFA'">
                {{sequence.updateDate | date: 'EEE d MMMM à HH:mm'}}
              </div>
            </div>
          </div>
        </ng-template>
      </ngb-panel>
    </ngb-accordion>
  </div>
</div>
